module.exports = __webpack_public_path__ + "img/Rivera-cropt.fca6c83d.png";